import { paymentResponse } from 'data/mock-data';

const mock = () => {
  return { data: paymentResponse };
};

export default mock;
